export const validEmail= new RegExp('^[A-Za-z0-9_.]+@[A-Za-z]{3,}(.com|.in|.nic.in|.ac.in|.edu.in)$');
export const phoneNumber= new RegExp('^(6|7|8|9){1}[0-9]{9}$');
//